module.exports = __webpack_public_path__ + "static/media/captura-de-pantalla-2012-08-22-a-las-10-01-52.041f3f2c.png";